import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { StorefrontBreadcrumbs } from '../../navigation/components/StorefrontBreadcrumbs';
import { SearchBar } from '../../search-bar/components/SearchBar';
import { ManageBuildDropdowns } from './ManageBuildDropdowns';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function BaseHeader({
  dataTestId = 'base-header',
  backBreadcrumb,
  pathKey,
  title
}) {
  return /*#__PURE__*/_jsx(Flex, {
    blockSize: "140px",
    flexDirection: "column",
    justifyContent: "center",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      "data-test-id": dataTestId,
      flexDirection: "row",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "200",
        children: [/*#__PURE__*/_jsx(StorefrontBreadcrumbs, {
          backBreadcrumb: backBreadcrumb,
          pathKey: pathKey,
          title: title
        }), /*#__PURE__*/_jsx(Text, {
          as: "h1",
          typography: "heading-600",
          children: title
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "end",
        flexDirection: "column",
        gap: "500",
        inlineSize: "600px",
        marginInline: "300",
        children: [/*#__PURE__*/_jsx(ManageBuildDropdowns, {}), /*#__PURE__*/_jsx(SearchBar, {})]
      })]
    })
  });
}